<template>
  <div class="home general" v-on:scroll="onScroll">
    <h1 class="section-title">
      Auditoría de controles
    </h1>

    <va-data-table
      class="ekitable"
      :items="connections"
      :columns="columns"
      no-data-html="<div class='no-data'>Sin conexiones</div>"
      :sticky-header="true"
      :loading="false"
      loading-text=""
    >
      <template #headerPrepend>
        <tr>
          <th colspan="5">
            <va-input
              class="search-bar"
              title="Buscar conexión"
              v-title
              placeholder="Dueño o sala"
              v-on:keyup.enter="onEnter"
              v-on:focusout="onEnter"
              v-model="search"
            >
              <template #prependInner>
                <font-awesome-icon :icon="['fa-solid', 'search']" />
              </template>
            </va-input>
          </th>
        </tr>
      </template>
      <template #cell(licenseOwner.fullname)="{ rowData }">
        <span v-if="rowData.licenseOwner">{{ ownerLabel(rowData.licenseOwner) }}</span>
      </template>
      <template #cell(status)="{ rowData }">
        {{ statusLabel(rowData.status) }}
      </template>
      <template #cell(actions)="{ rowData }">
        <va-button color="info" @click="openDetail(rowData.id)" title="Ver auditoría" v-title>
          <font-awesome-icon :icon="['fa-solid', 'eye']" />
        </va-button>
      </template>
    </va-data-table>
  </div>
</template>
<script>
import requester from "@/services/requester";

export default {
  data() {
    return {
      page: 1,
      isLoading: false,
      connections: [],
      continueLoading: true,
      search: '',
      columns: [
        { key: 'licenseOwner.fullname', sortable: false, label: 'Dueño de la licencia' },
        { key: 'room', sortable: false, label: 'Sala' },
        { key: 'status', sortable: false, label: 'Estado' },
        { key: 'songCount', sortable: false, label: 'Canciones' },
        { key: 'actions', sortable: false, label: '' }
      ]
    }
  },
  methods: {
    ownerLabel(owner) {
      if (owner.fullname && owner.email) {
        return owner.fullname + ' — ' + owner.email;
      }
      return owner.fullname || owner.email || '';
    },
    statusLabel(status) {
      if (status === 'connected') {
        return 'Conectado';
      }
      if (status === 'disconnected') {
        return 'Desconectado';
      }
      return status || '';
    },
    onEnter() {
      this.page = 1;
      this.connections = [];
      this.continueLoading = true;
      this.getFromApi();
    },
    async getFromApi(isScroll = false) {
      this.isLoading = true;
      const data = await requester.Get(`/control-connections/${this.page}/?search=${encodeURIComponent(this.search)}`, true);
      if (data.status === 200) {
        const pageItems = data.data.connections || [];
        if (!isScroll) {
          this.connections = pageItems;
        } else {
          this.connections = this.connections.concat(pageItems);
        }
        if (pageItems.length > 0) {
          this.page++;
          this.continueLoading = true;
        } else {
          this.continueLoading = false;
        }
      }
      this.isLoading = false;
    },
    onScroll(event) {
      if (!this.continueLoading || this.isLoading) {
        return;
      }
      const { target } = event;
      if (target.scrollTop + target.clientHeight >= target.scrollHeight) {
        this.getFromApi(true);
      }
    },
    openDetail(id) {
      this.$router.push({ name: 'controlAuditDetail', params: { id } });
    }
  },
  created() {
    this.onEnter();
  }
}
</script>
